module.exports = __webpack_public_path__ + "img/premium_blue.e8e5d6f5.svg";